import cn from 'classnames';
import { getCurrentLocationAndLanguage, LocationKey } from '@utils/location';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
interface CookieBarProps {
  className?: string;
  title: string;
  description?: string;
  hide?: boolean;
  action?: React.ReactNode;
}
interface AdditionalLink {
  id: string;
  text: string;
  url: string;
  newTab?: boolean;
}
const CookieBar: React.FC<CookieBarProps> = ({
  title,
  description,
  className,
  action,
  hide
}) => {
  const {
    t
  } = useTranslation('footer');
  const [location, setLocation] = useState('');
  const [language, setLanguage] = useState('en');
  useEffect(() => {
    const {
      location: detectedLocation
    } = getCurrentLocationAndLanguage();
    setLocation(detectedLocation);
    const activeLang = Cookies.get('NEXT_LOCALE') || 'en';
    setLanguage(activeLang);
  }, []);
  const additionalLinksByLocation: { [key in LocationKey]?: AdditionalLink[] } = {
    tr: [{
      id: 'privacy',
      text: t('privacy'),
      url: '/privacy',
      newTab: true
    }],
    uz: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }],
    ge: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }],
    iq: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }],
    az: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }],
    kz: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }],
    kg: [{
      id: 'privacy',
      text: t('privacy'),
      url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
      newTab: true
    }]
  };
  const linkMapping: {
    [key: string]: {
      [linkId: string]: string;
    };
  } = {
    'ge-ka': {
      privacy: 'https://flp.ge/downloads/ge/privacy/PrivacyNotice-FLPGE.pdf'
    },
    'uz-uz': {
      privacy: 'https://flpuz.com/downloads/uz/privacy/Privacy_Notice-FLPUZ-uz.pdf'
    },
    'uz-ru': {
      privacy: 'https://flpuz.com/downloads/uz/privacy/Privacy_Notice-FLPUZ-ru.pdf'
    },
    'az-az': {
      privacy: 'https://flpaze.com/downloads/az/privacy/PrivacyNotice-FLPAZ.pdf'
    },
    'kg-ru': {
      privacy: 'https://www.flpkgz.com/downloads/kg/privacy/Privacy_Notice-FLPKG-ru.pdf'
    },
    'kg-ky': {
      privacy: 'https://www.flpkgz.com/downloads/kg/privacy/Privacy_Notice-FLPKG-kyrg.pdf'
    },
    'tr-tr': {
      privacy: 'https://www.flptr.com/tr/privacy/'
    },
    'kz-kk': {
      privacy: 'https://www.flpkaz.com/downloads/kz/privacy/PrivacyNotice-FLPKZ.pdf'
    },
    'kz-ru': {
      privacy: 'https://www.flpkaz.com/downloads/kz/privacy/PrivacyNotice-FLPKZ.pdf'
    }
  };
  const defaultAdditionalLinks: AdditionalLink[] = [{
    id: 'privacy',
    text: t('privacy'),
    url: 'https://online.fliphtml5.com/yrbyn/orcf/#p=1',
    newTab: true
  }];
  let additionalLinksForLocation = additionalLinksByLocation[location as LocationKey] || defaultAdditionalLinks;
  const mappingKey = `${location}-${language}`;
  const currentMapping = linkMapping[mappingKey];
  if (currentMapping) {
    additionalLinksForLocation = additionalLinksForLocation.map(link => {
      if (link.id && currentMapping[link.id]) {
        return {
          ...link,
          url: currentMapping[link.id],
          newTab: true
        };
      }
      return link;
    });
  }
  const additionalLinks = additionalLinksForLocation;
  return <div className={cn('text-center p-5 bg-white dark:bg-zinc-950 text-sm flex-row justify-center items-center font-medium fixed bottom-0 w-full z-30 transition-all duration-300 ease-out shadow-cookies', {
    transform: true,
    'translate-y-0 opacity-100': !hide,
    'translate-y-full opacity-0': hide
  }, className)} data-sentry-component="CookieBar" data-sentry-source-file="cookie-bar.tsx">
      <span className="inline-block mb:block mb-3.5 leading-6 text-xs">
        {title}
        {additionalLinks?.map(link => <a key={link.id} href={link.url} target={link.newTab ? '_blank' : '_self'} rel="noopener noreferrer" className="ml-1 underline text-red-600 dark:text-red-400">
            {link.text}
          </a>)}
      </span>
      <span className="inline-block ltr:md:ml-3 rtl:md:mr-3">
        {description}
      </span>
      {action && action}
    </div>;
};
export default CookieBar;